import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Car, Eye, EyeSlash } from '@phosphor-icons/react';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ email: '', password: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(formData.email, formData.password);
      navigate('/admin');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Identifiants incorrects');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F5F5F5] flex items-center justify-center p-6">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-12 h-12 bg-[#E63946] flex items-center justify-center"><Car size={28} weight="bold" className="text-white" /></div>
          <div><span className="font-['Outfit'] text-2xl font-bold tracking-tight text-gray-900 block">ECOCASSE</span><span className="text-xs uppercase tracking-[0.2em] text-gray-400">Administration</span></div>
        </div>

        <div className="bg-white border border-gray-200 p-8 shadow-sm">
          <h1 className="font-['Outfit'] text-xl font-bold text-gray-900 mb-6 text-center">Connexion</h1>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div><label className="block text-gray-600 text-sm mb-2">Email</label><input type="email" value={formData.email} onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))} required className="w-full bg-white border border-gray-300 text-gray-900 p-4 focus:border-[#E63946]" placeholder="admin@ecocasse.fr" data-testid="login-email" /></div>
            <div><label className="block text-gray-600 text-sm mb-2">Mot de passe</label><div className="relative"><input type={showPassword ? 'text' : 'password'} value={formData.password} onChange={(e) => setFormData(prev => ({ ...prev, password: e.target.value }))} required className="w-full bg-white border border-gray-300 text-gray-900 p-4 pr-12 focus:border-[#E63946]" placeholder="••••••••" data-testid="login-password" /><button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700">{showPassword ? <EyeSlash size={20} /> : <Eye size={20} />}</button></div></div>
            <button type="submit" disabled={loading} className="w-full py-4 bg-[#E63946] text-white text-sm font-bold uppercase hover:bg-[#D90429] disabled:opacity-50 flex items-center justify-center gap-2" data-testid="login-submit">{loading ? <><div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>Connexion...</> : 'Se connecter'}</button>
          </form>
          <div className="mt-6"></div>
        </div>
        <div className="text-center mt-6"><a href="/" className="text-gray-400 hover:text-gray-700 text-sm">← Retour au site</a></div>
      </motion.div>
    </div>
  );
};

export default AdminLoginPage;
